<div class="overview-container">
<!-- ADMIN DASHBOARD -->
 @if(loggedInUser){
<app-admin-dashboard [project]="'V-ESTATE'">
</app-admin-dashboard>
 }

    <!-- SALES LEADS DASHBOARD -->
    @if(!loggedInUser){
<app-sales-dashboard
  [project]="'V-ESTATE'">
</app-sales-dashboard>
    }
</div>
